// Disable printing for command + p and for right click 
window.addEventListener('beforeprint', function(event) {
    
      if(!this.localStorage.getItem('allow_package_printing')) {
        event.preventDefault();
        alert('Printing is disabled for this content.');
      }
    
  });
  
  window.addEventListener('keydown', function(event) {
    if ((event.ctrlKey && event.key === 'p') || (event.metaKey && event.key === 'p')) {
      if(!this.localStorage.getItem('allow_package_printing')) {
        event.preventDefault();
        alert('Printing is disabled for this content.');
      }
    }
  });
  
  window.addEventListener('keyup', function(event) {
     if ((event.ctrlKey && event.key === 'p') || (event.metaKey && event.key === 'p')) {
      if(!this.localStorage.getItem('allow_package_printing')) {
        event.preventDefault();
        alert('Printing is disabled for this content.');
      }
    }
  });
  